import clsx from 'clsx'
import { ICodeProps } from './types'
import styles from './styles.module.scss'
import Prism from 'prismjs'
import 'prismjs/components/prism-bash.js'
import 'prismjs/components/prism-git.js'
import 'prismjs/components/prism-javascript.js'
import 'prismjs/components/prism-json.js'
import 'prismjs/components/prism-markup.js'
import 'prismjs/components/prism-shell-session.js'
import 'prismjs/components/prism-scss.js'
import 'prismjs/components/prism-solidity.js'
import 'prismjs/components/prism-typescript.js'
import 'prismjs/themes/prism-solarizedlight.css'

const CodePre = ({ code, defaultIsOpen, language }: ICodeProps) => {
  return (
    <pre
      className={clsx(`language-${language}`, styles.pre)}
      style={{ maxHeight: `${defaultIsOpen ? '460px' : '0px'}` }}
    >
      <code
        className={styles.code}
        dangerouslySetInnerHTML={{
          __html: Prism.highlight(code, Prism.languages[language], language),
        }}
      />
    </pre>
  )
}
export default CodePre
